import React, { useState } from 'react';
import { login } from '../services/api';
import '../styles/darkTheme.css'; // Reusing your existing styles

const BrokerLoginModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    api_key: '',
    client_code: '',
    password: '',
    totp_secret: ''
  });
  const [status, setStatus] = useState({ loading: false, message: '', error: false });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, message: '', error: false });

    try {
      const response = await login(formData); // Uses your existing api.js function
      if (response.status === 'success') {
        setStatus({ loading: false, message: 'Credentials saved successfully!', error: false });
        setTimeout(onClose, 1500); // Auto-close after success
      } else {
        setStatus({ loading: false, message: response.message || 'Failed to save.', error: true });
      }
    } catch (error) {
      setStatus({ loading: false, message: 'Server error. Please try again.', error: true });
    }
  };

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>Broker Credentials</h2>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div>
            <label style={labelStyle}>Client Code (Angel One)</label>
            <input type="text" name="client_code" value={formData.client_code} onChange={handleChange} required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>MPIN / Password</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>SmartAPI Key</label>
            <input type="text" name="api_key" value={formData.api_key} onChange={handleChange} required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>TOTP Secret</label>
            <input type="text" name="totp_secret" value={formData.totp_secret} onChange={handleChange} required style={inputStyle} />
          </div>

          {status.message && (
            <p style={{ color: status.error ? '#ff4444' : '#00C851', fontSize: '0.9rem', margin: '0' }}>
              {status.message}
            </p>
          )}

          <button type="submit" disabled={status.loading} style={submitBtnStyle}>
            {status.loading ? 'Saving...' : 'Save & Connect'}
          </button>
        </form>
      </div>
    </div>
  );
};

// --- Inline Styles for the Modal (to keep it matching your dark theme) ---
const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
};
const modalStyle = {
  backgroundColor: '#1e1e1e', padding: '30px', borderRadius: '8px', width: '400px', border: '1px solid #404040', color: 'white'
};
const closeBtnStyle = {
  background: 'none', border: 'none', color: '#b0b0b0', fontSize: '1.2rem', cursor: 'pointer'
};
const labelStyle = {
  display: 'block', marginBottom: '5px', fontSize: '0.9rem', color: '#b0b0b0'
};
const inputStyle = {
  width: '100%', padding: '10px', backgroundColor: '#2d2d2d', border: '1px solid #404040', borderRadius: '4px', color: 'white', boxSizing: 'border-box'
};
const submitBtnStyle = {
  padding: '12px', backgroundColor: '#2962FF', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', marginTop: '10px'
};

export default BrokerLoginModal;